import { HotelRateDisplayPreferences } from '../../../../../constants';

const NightlyPriceDisplay = ({ pricingPreference }) => (
  <div className="text-xs font-normal mb-1 text-gray-600" title={`Per night ${pricingPreference === HotelRateDisplayPreferences.NightlyPrice ? 'with' : 'excluding'} tax`}>
    Per night
    {' '}
    {pricingPreference === HotelRateDisplayPreferences.NightlyPrice ? 'w/' : 'w/o'}
    {' '}
    tax
  </div>
);
NightlyPriceDisplay.propTypes = {
  pricingPreference: HotelRateDisplayPreferences.isRequired,
};
export default NightlyPriceDisplay;
